var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6698 33.8214C44.3395 33.8214 45.7056 35.1875 45.7056 36.8571C45.7056 38.5268 44.3395 39.8929 42.6698 39.8929C41.0002 39.8929 39.6341 38.5268 39.6341 36.8571C39.6341 35.1875 41.0002 33.8214 42.6698 33.8214ZM42.6698 49C46.7681 49 51.4734 50.958 51.777 52.0357H33.5627C33.9118 50.9429 38.5868 49 42.6698 49ZM42.6698 30.7857C39.3154 30.7857 36.5984 33.5027 36.5984 36.8571C36.5984 40.2116 39.3154 42.9286 42.6698 42.9286C46.0243 42.9286 48.7413 40.2116 48.7413 36.8571C48.7413 33.5027 46.0243 30.7857 42.6698 30.7857ZM42.6698 45.9643C38.6172 45.9643 30.527 47.9982 30.527 52.0357V55.0714H54.8127V52.0357C54.8127 47.9982 46.7225 45.9643 42.6698 45.9643Z",
    fill: "#592EE5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.928576,
    y: 1.1875,
    width: 83.4821,
    height: 83.4821,
    rx: 41.7411,
    stroke: "#091F82",
    strokeWidth: 1.51786
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4286,
    height: 36.4286,
    fill: "white",
    transform: "translate(24.4556 24.7143)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanIcon);
export default __webpack_public_path__ + "static/media/fan_icon.4cd8f0188eb517a38f2250fac8fa2f14.svg";
export { ForwardRef as ReactComponent };